import { useIntl } from '@weenat/wintl'
import EmptyStateWithRipple from '../empty-state/EmptyStateWithRipple'
import Icons from '../Icons'

export const IrrigationRestrictionWeedget = () => {
  const { t } = useIntl()
  return (
    <Flex $flex={1} $flexDirection='column' $alignItems='center' $justifyContent='center' $gap='md'>
      <EmptyStateWithRipple
        Icon={Icons.Lock}
        title={t('weedget.restriction.expert_only')}
        description={t('ecommerce.plans.irrigation_data_restricted_for_non_expert')}
      />
    </Flex>
  )
}
